/**
 * ValueSet URLs for procedure fee categories, keyed by category name.
 * Each category has a matching ValueSet and CodeSystem. Several URLs keep an earlier category
 * name (for example `well-woman-other`) because practice fee data refers to them.
 */
export const PROCEDURE_FEE_VALUE_SETS = {
  LABOR_AND_DELIVERY: "http://quiltedhealth.com/fhir/ValueSet/global-maternity-care",
  OFFICE_VISIT_NEW_PATIENT: "http://quiltedhealth.com/fhir/ValueSet/office-visit-new-client",
  OFFICE_VISIT_ESTABLISHED_PATIENT:
    "http://quiltedhealth.com/fhir/ValueSet/office-visit-established-client",
  OFFICE_VISIT_CONSULTATION: "http://quiltedhealth.com/fhir/ValueSet/office-visit-consultation",
  HOME_VISIT_NEW_PATIENT: "http://quiltedhealth.com/fhir/ValueSet/home-visit-new-client",
  HOME_VISIT_ESTABLISHED_PATIENT:
    "http://quiltedhealth.com/fhir/ValueSet/home-visit-established-client",
  PROLONGED_SERVICES: "http://quiltedhealth.com/fhir/ValueSet/prolonged-services",
  FETAL_TESTING_AND_ULTRASOUND: "http://quiltedhealth.com/fhir/ValueSet/nst-us-doppler",
  PREVENTIVE_VISIT_NEW_PATIENT: "http://quiltedhealth.com/fhir/ValueSet/well-woman-new-client",
  PREVENTIVE_VISIT_ESTABLISHED_PATIENT:
    "http://quiltedhealth.com/fhir/ValueSet/well-woman-established-client",
  GYNECOLOGY_AND_CONTRACEPTION: "http://quiltedhealth.com/fhir/ValueSet/well-woman-other",
  NEWBORN_PEDIATRIC_CARE: "http://quiltedhealth.com/fhir/ValueSet/newborn-care",
  MEDICATIONS_CATHETERS_IV_OXYGEN:
    "http://quiltedhealth.com/fhir/ValueSet/medications-iv-catheters-oxygen",
  OTHER_PROCEDURES_AND_SERVICES:
    "http://quiltedhealth.com/fhir/ValueSet/other-procedures-and-services",
  FACILITY_FEE: "http://quiltedhealth.com/fhir/ValueSet/facility-fee",
  SCREENING_COUNSELING: "http://quiltedhealth.com/fhir/ValueSet/screening-counseling",
  TELEHEALTH_VISITS: "http://quiltedhealth.com/fhir/ValueSet/audio-visual-visits",
} as const;

export type ProcedureFeeValueSetKey = keyof typeof PROCEDURE_FEE_VALUE_SETS;
